import Vue from 'vue';
import App from './App.vue';
import router from './router';
Vue.config.devtools = true;
import * as global from '../../utils/active.js';

// 引入过滤器
import '../../filters';
// 浏览器默认样式重置
import 'normalize.css/normalize.css';
// 引入自定义的公共样式
import '@/assets/less/common.less';

// 引入fastclick
import FastClick from 'fastclick';
// ios input 组件引入fastclick 点击不灵敏
FastClick.prototype.focus = function(targetElement) {
    let length;
    // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
    if (
        global.trident().iPhone &&
        targetElement.setSelectionRange &&
        targetElement.type.indexOf('date') !== 0 &&
        targetElement.type !== 'time' &&
        targetElement.type !== 'month' &&
        targetElement.type !== 'email'
    ) {
        length = targetElement.value.length;
        targetElement.focus(); // 加入这一句话
        targetElement.setSelectionRange(length, length);
    } else {
        targetElement.focus();
    }
};
// 全局混入
import globalMixins from '@/mixins/global';

import * as trackEvent from '../../utils/trackEvent.js';
Vue.prototype.$sensors = trackEvent;
// SVG 引入
import '@/icons';
// 调用接口封装
import Api from './service';
// 全局loding
import indicator from '@/components/foundation/indicator/index.js';
import Toast from '@/components/foundation/toast/index.js';
import ShareSourceDialog from '@/components/foundation/shareSourceDialog/index.js';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
// mock 数据
if (process.env.VUE_APP_MOCK === 'yes') require('./service/mock/');
const ActivityId = 2030162478;
Vue.prototype.$activityId = ActivityId;
// 将调用接口的函数扩展到每个组件中
// 强制登录
Vue.prototype.$http = Api;
Vue.prototype.$loding = indicator;
FastClick.attach(document.body); // 使用fastclick
Vue.prototype.$toast = Toast;
Vue.prototype.$sourceDialog = ShareSourceDialog;
// 神策埋点自定义插件
import sensors from '@/utils/sensors';
// 使用神策埋点自定义插件
Vue.use(sensors);

// 全局混入
Vue.mixin(globalMixins);
Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV === 'development';

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
